import { useTranslation } from "react-i18next";
import { Typography, Button } from "mobily-ui-library/lib";

import EmptyCart from "../../assets/EmptyCart.svg";
import "./EmptyCartPage.scss";

const win: any = window;

const EmptyCartPage = () => {
    const { t } = useTranslation();

    const handleExploreClick = () => {
        window.location.href = win["productUrl"];
    };

    return (
        <div className="EmptyCartPage__container">
            <img className="ECP__Image" src={EmptyCart} alt="EmptyCart" />
            <Typography className="ECP__boldText">
                {t("your_cart_is_empty")}
            </Typography>
            <Typography className="ECP__subText">
                {t("Go_find_something_nice")}
            </Typography>
            <Button
                id={"btn_go_to_shop_id"}
                className="ECP__EmptyBtn"
                primary={true}
                onClick={handleExploreClick}
            >
                {t("EXPLORE_SHOP")}
            </Button>
        </div>
    );
};

export default EmptyCartPage;
